import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Worksheet, Button } from '@bigcommerce/big-design';

import { updateShipments } from '../../redux/actions/purchaseOrders';

const UpdateShipmentModal = ({ payload, showUpdateShipmentModal, setShowUpdateShipmentModal, shipment, sendUpdateShipments, bigcommerceSettings, shipments, setShipments, purchaseOrderId }) => {
  const [companyName, setCompanyName] = useState(shipment.company_name);
  const [tracking, setTracking] = useState(shipment.tracking);
  const [taxes, setTaxes] = useState(shipment.taxes);
  const [other, setOther] = useState(shipment.other);

  const shipmentJson = () => {
    return {
      id: shipment.id,
      company_name: companyName,
      tracking: tracking,
      taxes: taxes,
      other: other
    }
  }

  const changeCompany = (event) => {
    let value = event.target.value;
    setCompanyName(value);
  }

  const changeTracking = (event) => {
    let value = event.target.value;
    setTracking(value);
  }

  const changeTaxes = (event) => {
    let value = event.target.value;
    setTaxes(value);
  }

  const changeOther = (event) => {
    let value = event.target.value;
    setOther(value);
  }

  const update = () => {
    let newShipments = [...shipments];
    let updatedShipment = shipmentJson();
    let toUpdateIndex = newShipments.findIndex((ship) => ship.id === shipment.id);

    newShipments[toUpdateIndex] = updatedShipment;

    sendUpdateShipments(payload, purchaseOrderId, newShipments);
    setShipments(newShipments);
    setShowUpdateShipmentModal(false);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowUpdateShipmentModal(false),
          },
          { text: 'Update Shipment', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Update Shipment"
        isOpen={showUpdateShipmentModal}
        onClose={() => setShowUpdateShipmentModal(false)}
      >
        <Input
          description={`Current value: ${shipment.company_name}`}
          label="Shipping Company"
          onChange={changeCompany}
          placeholder="Shipping Company"
          type="text"
          value={companyName}
          required
        />
        
        <Input
          description={`Current value: ${shipment.tracking}`}
          label="Tracking #"
          onChange={changeTracking}
          placeholder="Tracking #"
          type="text"
          value={tracking}
          required
        />

        <Input
          description={`Current value: ${shipment.taxes}`}
          label="Taxes/Duties"
          onChange={changeTaxes}
          placeholder="Taxes/Duties"
          type="number"
          value={taxes}
          required
        />

        <Input
          description={`Current value: ${shipment.other}`}
          label="Other"
          onChange={changeOther}
          placeholder="Other"
          type="text"
          value={other}
          required
        />

        
      </Modal>
    </>
  )

}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
});

const mapDispatchToProps = (dispatch) => ({
  sendUpdateShipments: (payload, purchaseOrderId, shipments) => dispatch(updateShipments(payload, purchaseOrderId, shipments)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShipmentModal);
